// 2026-08-04 - FormuLearning - Step1 분자 식별(SMILES) 게시 스토어 (이슈 #56)
// 파일 위치: frontend/src/stores/moleculeStore.ts
// 목적: Step1 검색 결과인 canonical_smiles 를 Step2가 즉시 받아 쓰게 한다.
//       6개 Step 카드는 한 페이지에 동시 마운트되고, Step2Card 는 종전에 마운트 시점 1회만
//       GET /step1 로 SMILES 를 읽었다. 그래서 신규 프로젝트(카드 전부 펼침)에서 Step1 검색을
//       마쳐도 Step2 의 "Run DB Search & AI Prediction" 이 비활성인 채로 남았다.
//       Step1Card 가 값을 발행하고 Step2Card 가 구독한다 — lotStore(이슈 #50 F-8)와 동일 취지.
//
// 주의: Step1 카드가 접혀 있으면 Step1Card 는 언마운트되어 발행자가 없다. 따라서 Step2Card 는
//       마운트 시 서버 조회로 이 스토어를 초기 충전하고, 이후에는 스토어를 단일 출처로 읽는다.

import { create } from 'zustand'

interface MoleculeState {
  /** 현재 프로젝트 Step1 의 canonical_smiles. 미검색·검색 중 초기화 구간에서는 null. */
  smiles: string | null
  setSmiles: (smiles: string | null) => void
  clear: () => void
}

export const useMoleculeStore = create<MoleculeState>((set) => ({
  smiles: null,
  setSmiles: (smiles) =>
    set((s) => (s.smiles === smiles ? s : { smiles })), // 동일 값이면 리렌더 억제
  clear: () => set({ smiles: null }),
}))
